document.addEventListener("DOMContentLoaded", function () {
    
    // Accordion functionality
    document.querySelectorAll('.rt-accordion-header').forEach(header => {

        header.addEventListener('click', function () {
            
            const item = this.closest('.rt-accordion-item');
            const allItems = item.parentElement.querySelectorAll('.rt-accordion-item');
            
            // Remove active-open from all items
            allItems.forEach(i => i.classList.remove('active-open'));
            
            // Add active-open to clicked item
            item.classList.add('active-open');
            
        });
    });

}); 